import dynamic from 'next/dynamic';

const Layout = dynamic(() => import('../components/layout'));

export default function NotFound() {
  return (
    <Layout>
      <section className='flex flex-col items-center justify-items-center justify-center h-96'>
        <div className='flex-1 flex flex-col items-center justify-items-center justify-center'>
          <h1 className='text-3xl font-serif'>Page not found</h1>
        </div>
      </section>
    </Layout>
  )
}
